import create from "zustand";
import indexService from "../service/index.service";
import {
    CSmsCode,
    CSmsCodeLogin,
    LazyList,
    UserContent,
} from "../typing/index.d";
import { uuid } from "./utils";

function getUUid() {
    let id = localStorage.getItem("collectAdviceUUid");
    if (!id) {
        id = uuid();
        localStorage.setItem("collectAdviceUUid", id);
    }

    return id;
}

const useIndexStore = create<State>((set, get) => ({
    loading: false,
    userContent: new UserContent(),
    changeUserContent: (field, content) => {
        let { userContent } = get();
        userContent[field] = content;
        set({ userContent });
    },
    smsCode: new CSmsCode(getUUid()),
    fetchSmsCode: async () => {
        let { smsCode, userContent } = get();
        smsCode.tel = userContent.phone;
        smsCode.timestamp = Number((Date.now() / 1000).toFixed(0));
        let res = await indexService.sms(smsCode);
        // 测试
        // if (res.data.status_code == 1) {
        //     userContent.smsCode = res.data.data.code;
        //     set({});
        // }
        return res;
    },
    smsCodeLogin: new CSmsCodeLogin(getUUid()),
    loginLoading: false,
    login: async () => {
        let { smsCodeLogin, userContent, loginLoading } = get();
        if (loginLoading) {
            return;
        }
        set({
            loading: true,
            loginLoading: true,
        });
        smsCodeLogin.tel = userContent.phone;
        smsCodeLogin.timestamp = Number((Date.now() / 1000).toFixed(0));
        smsCodeLogin.code = userContent.smsCode!;
        let res: any;
        try {
            res = await indexService.login(smsCodeLogin);
            if (res.data.status_code == 0) {
                set({ loading: false });
            }
        } catch (err) {
            set({ loading: false });
            alert("手机或验证码错误");
        } finally {
            set({
                loginLoading: false,
            });
        }
        return res;
    },
    submit: async () => {
        let { userContent, selTypeInfo } = get();
        let res = await indexService.submit(
            userContent,
            selTypeInfo.title.replace("<br/>", ""),
        );
        userContent.smsCode = "";
        set({
            loading: false,
            userContent,
        });
        return res;
    },
    selTypeInfo: null,
    setSelTypeInfo: (info) => {
        set({
            selTypeInfo: info,
        });
    },
    lazyList: new LazyList(),
    choosenList: async (isClear = false) => {
        let { lazyList } = get();
        if (isClear) {
            let search = lazyList.searchKey;
            lazyList = new LazyList();
            lazyList.searchKey = search;
        }
        let res = await indexService.choosen_list(
            lazyList.searchKey,
            lazyList.page,
            lazyList.per,
        );
        lazyList.list = res.data.infos;
        lazyList.all_count = res.data.all_count;
        set({ lazyList });
    },
    search: async (key) => {
        let { lazyList, choosenList } = get();
        let k = key.replace("<br/>", "");
        k = k == "全部" ? "" : key;
        lazyList.searchKey = k;
        choosenList(true);
    },
    changePage: async (page) => {
        let { lazyList, choosenList } = get();
        lazyList.page = page;
        choosenList();
    },
}));

export default useIndexStore;

type State = {
    loading: boolean;
    userContent: UserContent;
    changeUserContent: (field: keyof UserContent, content: any) => void;
    smsCode: CSmsCode;
    fetchSmsCode: () => Promise<any>;
    smsCodeLogin: CSmsCodeLogin;
    loginLoading: boolean;
    login: () => Promise<any>;
    submit: () => Promise<any>;
    selTypeInfo: any;
    setSelTypeInfo: (info: any) => void;
    lazyList: LazyList;
    choosenList: (isClear?: boolean) => Promise<void>;
    search: (key: string) => Promise<void>;
    changePage: (page: number) => Promise<void>;
};
